













































































































import PageBody from "@/components/PageBody.vue";
import { UserHttp } from "@/mixins/http/user";
import { Component, Mixins } from "vue-property-decorator";
@Component({ components: { "page-body": PageBody } })
export default class ChangePassword extends Mixins(UserHttp) {
	loading: boolean = false;
	password: string = "";
	confirmPassword: string = "";
	formValid: boolean = false;
	showPasswordChangedSuccessfully: boolean = false;
	errorMessage: string = "";
	passwordRules = [
		(inputText: string) => this.isSet(inputText) || "Password is required",
		(inputText: string) => inputText.length >= 8 || "Password must be 8 letters or longer",
	];

	passwordsMatchRules = [
		(inputText: string) => this.isSet(inputText) || "Enter your password again to confirm it",
		(inputText: string) => this.compareToPasswordField(inputText) || "Passwords must match",
	];

	attemptPasswordChange(): void {
		this.loading = true;
		this.changePassword(this.password)
			.then(() => {
				this.showPasswordChangedSuccessfully = true;
				this.errorMessage = "";
				(this.$refs.form as any).reset();
			})
			.catch((error: any) => {
				this.errorMessage = error.response.data.message;
				this.showPasswordChangedSuccessfully = false;
			})
			.finally(() => (this.loading = false));
	}

	private compareToPasswordField(confirmPasswordText: string) {
		return confirmPasswordText == this.password;
	}

	private isSet(text: string): boolean {
		return text != undefined && text != null && text != "";
	}

	get canAttemptPasswordChange(): boolean {
		return this.formValid;
	}
}
